import { AppEmbed, EmbedEvent, MessagePayload, Page } from '@thoughtspot/visual-embed-sdk'
import { useEffect } from 'react'
import EmbeddedContent from '../../components/EmbeddedContent'
import { logError } from '../../services/error/logger'
import { ALL_HIDDEN_ACTIONS, COMMON_THOUGHTSPOT_ACTIONS } from '../../constants'
import { useNavigate } from 'react-router-dom'
import { convertTsUrlToHfIntelligenceUrl } from '../../services/route/tsHfIntelligenceUrlMapper'
import type { IMessagePayload } from '../../types'

export const embedId = 'embed-dashboards'

/**
 * Main dashboard page accessible by the URL: /dashboards
 * This page matches the Thoughtspot 'Liveboards' page under Insights
 */

const Dashboards = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleError = (messagePayload: MessagePayload) => {
      const embedError = new Error(`Dashboards: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    }

    const handleRouteChange = (messagePayload: IMessagePayload) => {
      const route = messagePayload.data.currentPath
      const dashboardUrl = convertTsUrlToHfIntelligenceUrl(route)
      navigate(dashboardUrl)
    }

    const appEmbed = new AppEmbed(`#${embedId}`, {
      pageId: Page.Liveboards,
      hiddenActions: ALL_HIDDEN_ACTIONS,
      ...COMMON_THOUGHTSPOT_ACTIONS,
    })

    void appEmbed
      .on(EmbedEvent.Error, (messagePayload: MessagePayload) => {
        handleError(messagePayload)
      })
      .on(EmbedEvent.RouteChange, (messagePayload: IMessagePayload) => {
        handleRouteChange(messagePayload)
      })
      .render()

    return () => {
      appEmbed.off(EmbedEvent.Error, handleError)
      appEmbed.off(EmbedEvent.RouteChange, handleRouteChange)
    }
  }, [navigate])

  return (
    <EmbeddedContent
      id={embedId}
      testId={embedId}
    />
  )
}

export default Dashboards
